import { render, staticRenderFns } from "./NewBox.vue?vue&type=template&id=9a2deaf2"
import script from "./NewBox.vue?vue&type=script&lang=js"
export * from "./NewBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports